import { PublicationsDB } from "./publicationsDb";

export class IdentifiersRepository {
  private readonly memoryCache = new Map<string, string>();

  constructor(private readonly db: PublicationsDB) {
    db.getIdentifiers().then((entries) =>
      entries.forEach(({ storagePath, identifier }) =>
        this.memoryCache.set(storagePath, identifier)
      )
    );
  }

  public async get(storagePath: string): Promise<string | null> {
    if (this.memoryCache.has(storagePath)) {
      return this.memoryCache.get(storagePath);
    }

    return await this.db.getIdentifier(storagePath);
  }

  public async set(storagePath: string, identifier: string): Promise<void> {
    this.memoryCache.set(storagePath, identifier);
    await this.db.setIdentifier(storagePath, identifier);
  }
}
